import { createResource, type RouteResourceResponse } from 'react-resource-router';

import { eocUserResource } from '@atlassian/eoc-resources';

import { getForwardingRules, getNotificationPreferences } from '../endpoints';

// Redefined here since it is not exported from RRR.
type ResourceDependencies = {
	[type: string]: RouteResourceResponse;
};

const createNotificationPreferencesResource = (
	checkConsolidationOnRouteDependency?: (dependencies: ResourceDependencies) => boolean,
	depends?: string[],
) =>
	createResource({
		type: 'notificationPreferencesResource',
		getKey: () => 'notificationPreferencesResource',
		getData: ({ dependencies, match }) => {
			const targetAccountId = match.params?.targetAccountId;
			const isConsolidated = checkConsolidationOnRouteDependency
				? // @ts-ignore - Type 'undefined' is not assignable to type 'RouteResourceResponse'.
					// This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
					checkConsolidationOnRouteDependency(dependencies)
				: true;

			if (!isConsolidated) {
				return null;
			}
			return getNotificationPreferences(targetAccountId);
		},
		isBrowserOnly: true,
		depends,
	});

const createForwardingRulesResource = (
	checkConsolidationOnRouteDependency?: (dependencies: ResourceDependencies) => boolean,
	depends?: string[],
) =>
	createResource({
		type: 'forwardingRulesResource',
		getKey: () => 'forwardingRulesResource',
		getData: ({ dependencies, match }) => {
			const targetAccountId = match.params?.targetAccountId;
			const isConsolidated = checkConsolidationOnRouteDependency
				? // @ts-ignore - Type 'undefined' is not assignable to type 'RouteResourceResponse'.
					// This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
					checkConsolidationOnRouteDependency(dependencies)
				: true;

			if (!isConsolidated) {
				return null;
			}

			return getForwardingRules(targetAccountId).then(({ values }) => values);
		},
		isBrowserOnly: true,
		depends,
	});

export { createNotificationPreferencesResource, eocUserResource, createForwardingRulesResource };
